import { motion } from "framer-motion";

const PROOF = [
  { big: "0 %", label: "De pisoteo del cultivo: nada toca tu planta" },
  { big: "24–72 h", label: "De espera en zonas activas, no semanas de cola" },
  { big: "1 ficha", label: "Técnica firmada por cada vuelo, con litros y dosis" },
];

const Prueba = () => (
  <section id="prueba" data-testid="prueba-section" className="relative bg-[#151A1F] border-b border-[#00A651]/25 py-16 sm:py-20 overflow-hidden">
    <video
      className="absolute inset-0 w-full h-full object-cover"
      autoPlay
      muted
      loop
      playsInline
      poster="/fotos/dron-noche.webp"
      aria-hidden="true"
    >
      <source src="/fotos/portada-dron.webm" type="video/webm" />
      <source src="/fotos/portada-dron.mp4" type="video/mp4" />
    </video>
    <div className="absolute inset-0 bg-[#151A1F]/82" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl px-6 sm:px-10">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-[#00A651]"
      >
        Lo que cambia en tu lote
      </motion.p>
      <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 border-t border-l border-white/10">
        {PROOF.map((p, i) => (
          <motion.div
            key={p.big}
            data-testid={`prueba-item-${i}`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            className="border-b border-r border-white/10 p-6 sm:p-8"
          >
            <p className="font-display font-bold text-3xl sm:text-5xl text-[#F6F7F5] tracking-tight tabular">{p.big}</p>
            <p className="mt-3 text-xs sm:text-sm text-[#F6F7F5]/55 leading-relaxed">{p.label}</p>
          </motion.div>
        ))}
      </div>
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.3 }}
        className="mt-6 font-mono-tech text-[10px] uppercase tracking-[0.2em] text-[#F6F7F5]/35"
      >
        Cifras de referencia de la categoría · Los testimonios de la primera campaña se publican acá
      </motion.p>
    </div>
  </section>
);

export default Prueba;
